var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",style:({
    'background-color': _vm.back_color,
    color: _vm.text_color,
    borderRadius: _vm.border_radius,
    borderWidth: _vm.border ? '1px' : '0',
    borderStyle: _vm.border ? 'solid' : 'none',
    borderColor: _vm.border_color,
    fontSize: _vm.font_size,
    fontFamily: _vm.font_family,
    height: _vm.height,
    fontWeight: _vm.font_weight
  }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleButton}},[_vm._v("\n  "+_vm._s(_vm.button_text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4782222b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseBtnDetail.vue
// module id = null
// module chunks = 